import { classNames } from "@gettactic/helpers/src/css/classNames";
import {
  InteractiveZone,
  InteractiveZoneCircle
} from "@gettactic/helpers/src/map/types";
import { getInitials } from "@gettactic/helpers/src/strings/getInitials";
import React from "react";
import { InteractiveActiveSpot } from "./InteractiveActiveSpot";
import { getRandomColor } from "@gettactic/helpers/src/colors";
import { MAP_SPOT_COLORS } from "../../../themes/mapSpotColors";

export type CircleProfilePhotoProps = {
  zone: InteractiveZone;
  id: string;
  profilePhoto: string;
  name: string;
  hasCheckedIn: boolean;
  restricted?: boolean;
  privacy: boolean;
  grayscale?: boolean;
};

export const CircleProfilePhoto: React.FC<CircleProfilePhotoProps> = ({
  zone,
  id,
  profilePhoto,
  name,
  hasCheckedIn,
  restricted = false,
  privacy = false,
  grayscale = false
}) => {
  const circle = zone.circle;
  const { strokeWidth, transform, cx, cy, r } = circle as InteractiveZoneCircle;
  const photoName = privacy ? "" : name;
  const initials = getInitials(photoName || "");
  const bgColor = grayscale
    ? "gray"
    : (initials ? getRandomColor({ string: photoName }) : undefined) ||
      MAP_SPOT_COLORS.spotAvatarFallbackFill.defaultValue;

  return (
    <InteractiveActiveSpot
      className={classNames(hasCheckedIn && "has-check-in")}
      title={photoName}
      label={initials}
      bgColor={bgColor}
      zone={zone}
      isFaded={restricted}
    >
      {!!profilePhoto && !privacy && (
        <>
          <defs>
            <clipPath id={`circle-profile-photo-${id}`}>
              <circle cx={cx} cy={cy} r={r - strokeWidth / 2} />
            </clipPath>
          </defs>
          <circle
            className="wrapper-circle"
            {...circle}
            stroke="white"
            fill="white"
            style={
              bgColor
                ? {
                    fill: bgColor
                  }
                : undefined
            }
          />
          <title>{photoName}</title>
          <image
            width={r * 2}
            height={r * 2}
            xlinkHref={profilePhoto}
            clipPath={`url(#circle-profile-photo-${id})`}
            transform={transform}
            x={cx ? cx - r : -r}
            y={cy ? cy - r : -r}
            preserveAspectRatio="xMidYMid slice"
            className={grayscale ? "grayscale" : ""}
          />
        </>
      )}
    </InteractiveActiveSpot>
  );
};
